export const baseURlNoAPI = process.env.REACT_APP_API_URL || "https://www.lift14.com";
export const baseURL = `${baseURlNoAPI}/api`;

// base url without '/api'

export const baseNew =  `${baseURlNoAPI}`;

// updated
 